import { Spinner } from "react-bootstrap";

interface Props {
  align?: "center" | "left" | "right";
  isLoading: boolean;
  showText?: boolean;
  text?: string;
  className?: string;
  animation?: "border" | "grow";
  color?: string;
  children?: React.ReactNode;
}

const Loading = ({
  align = "center",
  isLoading = false,
  showText = true,
  text = "Loading...",
  children,
  className,
  animation = "border",
  color = "text-primary",
}: Props) => {
  return isLoading ? (
    <div
      className={`d-flex justify-content-${align} align-items-center ${color} ${className}`}
    >
      <Spinner className="me-2" animation={animation} size="sm" />
      {showText && text}
    </div>
  ) : (
    children
  );
};

export default Loading;
